module.exports = "    <div class=\"hp-module\">\n        <div class=\"hp-inner\">\n            <ng-include src=\"'app/common/footer/legalDocuments/eSignatureDisclosures.html'\"></ng-include>\n        </div>\n    </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/legalDocuments/legalDocuments.html
// module id = 855
// module chunks = 1